import { render, staticRenderFns } from "./WorkspaceNotification.vue?vue&type=template&id=5ba8503c&"
import script from "./WorkspaceNotification.vue?vue&type=script&lang=js&"
export * from "./WorkspaceNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports